import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import * as fromRootStore from 'src/app/_apps/root/store';
import { BackAuthEntitySearchResult } from 'src/app/_common/models/search-result';
import { ISearchCategory } from 'src/app/_apps/root/root.constants';
import { SearchCategory } from './search-category';
import { Entity } from 'src/app/_apps/auth/domain/models/back';

@Component({
    selector: 'aa-back-auth-entity-category',
    templateUrl: './search-category.component.html',
    styleUrls: [
        './search-category.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BackAuthEntityCategoryComponent extends SearchCategory<Entity> implements OnInit
{
    @Input() category: ISearchCategory;
    public results: Observable<BackAuthEntitySearchResult[]> = of([]);

    constructor(private store: Store<IAuroraState>)
    {
        super();
    }

    ngOnInit ()
    {
        this.results = this.store
            .pipe(
                select(fromRootStore.getBackAuthEntitiesSearchResults)
            );
    }
}
